import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d8845cf2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "space_content_bg" }
const _hoisted_2 = {
  key: 0,
  class: "space_empty"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无内容", -1))
const _hoisted_5 = { class: "bottom_creat_bg" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "创建空间", -1))
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "绑定天海现场空间", -1))
const _hoisted_10 = {
  key: 1,
  class: "space_info_bg"
}
const _hoisted_11 = { class: "space_info" }
const _hoisted_12 = { class: "user_space" }
const _hoisted_13 = { class: "space_status_bg" }
const _hoisted_14 = { class: "space_status_text" }
const _hoisted_15 = ["src"]
const _hoisted_16 = ["textContent"]
const _hoisted_17 = ["textContent"]
const _hoisted_18 = { class: "bottom_creat_bg" }
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "创建空间", -1))
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "绑定天海现场空间", -1))
const _hoisted_23 = {
  key: 0,
  class: "tips_bg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_SpaceModelList = _resolveComponent("SpaceModelList")!
  const _component_BindSpaceView = _resolveComponent("BindSpaceView")!
  const _component_DialogView = _resolveComponent("DialogView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.hasSpaceInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "empty_img",
            src: require('../assets/images/collect-no.svg')
          }, null, 8, _hoisted_3),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "bottom_button creat_space_button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.creatButtonClick && _ctx.creatButtonClick(...args)))
            }, [
              _createElementVNode("img", {
                class: "space_button_icon",
                src: require('../assets/images/creat_space_btn.svg'),
                alt: ""
              }, null, 8, _hoisted_6),
              _hoisted_7
            ]),
            _createElementVNode("button", {
              class: "bottom_button bind_space_button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.bindButtonClick && _ctx.bindButtonClick(...args)))
            }, [
              _createElementVNode("img", {
                class: "space_button_icon",
                src: require('../assets/images/bind_space_icon.svg'),
                alt: ""
              }, null, 8, _hoisted_8),
              _hoisted_9
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_image, {
                class: "space_img",
                src: _ctx.spaceInfo.coverImgUrl
              }, null, 8, ["src"]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", {
                  class: _normalizeClass([_ctx.spaceInfo.status == 2 ? 'space_status_mark_live' : 'space_status_mark_end'])
                }, null, 2),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.spaceInfo.status == 2 ? 'Live' : 'Ended'), 1)
              ]),
              _createElementVNode("button", {
                class: "unbind_or_delete_btn",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.unbindOrDeleteBtnClick && _ctx.unbindOrDeleteBtnClick(...args)))
              }, [
                _createElementVNode("img", {
                  class: "unbind_or_delete_icon",
                  src: require('../assets/images/unbind_or_delete_btn.svg'),
                  alt: ""
                }, null, 8, _hoisted_15)
              ]),
              _createElementVNode("button", {
                class: "goto_space_btn",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.gotoSpaceBtnClick && _ctx.gotoSpaceBtnClick(...args)))
              }, "前往空间")
            ]),
            _createElementVNode("span", {
              class: "space_name",
              textContent: _toDisplayString(_ctx.spaceInfo.activityName)
            }, null, 8, _hoisted_16),
            _createElementVNode("span", {
              class: "space_creator",
              textContent: _toDisplayString(_ctx.spaceInfo.creatorName)
            }, null, 8, _hoisted_17)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              class: "bottom_button creat_can_not_click",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.creatButtonClick && _ctx.creatButtonClick(...args)))
            }, [
              _createElementVNode("img", {
                class: "space_button_icon",
                src: require('../assets/images/creat_space_btn_disable.svg'),
                alt: ""
              }, null, 8, _hoisted_19),
              _hoisted_20
            ]),
            _createElementVNode("button", {
              class: "bottom_button bind_can_not_click",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.bindButtonClick && _ctx.bindButtonClick(...args)))
            }, [
              _createElementVNode("img", {
                class: "space_button_icon",
                src: require('../assets/images/bind_space_icon_disable.svg'),
                alt: ""
              }, null, 8, _hoisted_21),
              _hoisted_22
            ])
          ]),
          (_ctx.tipsText)
            ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.tipsText), 1))
            : _createCommentVNode("", true)
        ])),
    (_ctx.showSpaceModelList)
      ? (_openBlock(), _createBlock(_component_SpaceModelList, {
          key: 2,
          linkardId: _ctx.linkardId,
          linkardType: _ctx.linkardType,
          onDismissModelList: _ctx.dismissModelList
        }, null, 8, ["linkardId", "linkardType", "onDismissModelList"]))
      : _createCommentVNode("", true),
    (_ctx.showBindSpaceView)
      ? (_openBlock(), _createBlock(_component_BindSpaceView, {
          key: 3,
          linkardId: _ctx.linkardId,
          onDismissBindView: _ctx.dismissBindView
        }, null, 8, ["linkardId", "onDismissBindView"]))
      : _createCommentVNode("", true),
    (_ctx.showDialog)
      ? (_openBlock(), _createBlock(_component_DialogView, {
          key: 4,
          onSureBtnClick: _ctx.sureButtonClick,
          onCancelBtnClick: _ctx.cancelButtonClick,
          showDialog: _ctx.showDialog,
          "dialog-text": _ctx.dialogText,
          "sure-button": "确认删除",
          "cancel-button": "返回"
        }, null, 8, ["onSureBtnClick", "onCancelBtnClick", "showDialog", "dialog-text"]))
      : _createCommentVNode("", true)
  ]))
}